<template>
    <el-form :model="callBidNotice" :rules="callBidNoticeRules" ref="shNoticeFormInfo">
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label ">
                    <label class="required">公告名称</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="title">
                        <el-input class="width-1-5x" :disabled="add==null" v-model="callBidNotice.title" placeholder="请输入内容"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label ">
                    <label class="required">上传附件</label>
                </div>
                <div class="form-value">
                    <span v-if="add != null">
                    <swb-file-upload fileGroup="image-goods" :onBeforeUpload="onBeforeUpload" :onProgress="onProgress" :onDone="onUploadDone" :multipleFile="true"></swb-file-upload>
                     </span>
                    <div class="file-area clearfix" v-if="enrollfile.length >0">
                        <swb-file-item v-for="(file, index) in enrollfile" :trackKey="index" :fileName="file.fileName" :fileUuid="file.fileUuid" :fileBrowseUrl="file.fileBrowseUrl" :fileDownloadUrl="file.fileDownloadUrl" :fileMd5="file.fileMd5" :deletable="true" :onDelete="deleteFile"></swb-file-item>
                    </div>
                </div>
            </div>
            <div class="form-group center" v-if="add != null">
                <div class="form-label">
                    <label>模板名称</label>
                </div>
                <div class="form-value">
                    <el-select class="width-1-5x" v-model="bizTplId" placeholder="请选择">
                        <el-option v-for="item in bizTplList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                    <input type="button" class="swb-btn swb-btn-link" @click="getBizNoticeContentModel()" value="生成模板"/>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label ">
                    <label class="required">内容信息</label>
                </div>
                <div class="form-value">
                    <swb-ck-editor :content="callBidNotice.content" ref="theCkEditor" :imageXtHandler="imageXtHandler"></swb-ck-editor>
                </div>
            </div>
        </div>
    </el-form>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import callBidApi from '../../api/callBid'
    import merchtComnApi from '../../api/merchtComn'

    import SwbCkEditor from '../ctrl/CkEditor';
    Vue.regist(SwbCkEditor);

    export default {
        name: 'swb-call-bid-notice-save',
        desc: '保存招标公告',
        props: ['docId', 'id', 'add', 'state'],
        data: function () {
            let self = this;
            let title = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            };
            return {
                imageXtHandler: function (ckEditor) {
                    //
                    self.showDialogIntroImg(ckEditor);
                },

                enrollfile: [],
                callBidNotice: {
                    content: ''
                },
                biding: null,
                openBid: null,
                callBidDocInfo: {},
                radio2: false,
                radio3: false,
                enrollCloseTime: null,
                openTime: null,
                closeTime: null,
                resultPublishTime: null,
                bizTplList: [],
                bizTplId: null,
                files: [],

                callBidNoticeRules: {
                    title: [{
                        validator: title,
                        trigger: 'blur'
                    }],
                },
            }
        },
        beforeDestroy(){
            if(this.callBidNotice != null) {
                this.callBidNotice.content = '';
            }
        },
        created: function () {

            if(!Utils.isNoB(this.id)) {
                this.getCallBidNotice();
            }
            this.biding = getEnumInfoWith('callBidDocState', 'name', 'Biding').value;
            this.openBid = getEnumInfoWith('callBidDocState', 'name', 'OpenBid').value;
            this.getCallBidDoc();
            this.getBizTplList();
        },
        methods: {
            onBeforeUpload: function (fileItems, uploader) {
                if(fileItems.length === 0) {
                    this.$message.error('喂，你还没选择要上传的文件吧');
                    return false;
                }
            },
            onProgress: function (progress) {
                let self = this;
                self.percentage = Math.floor((progress.loaded / progress.total) * 100);
            },
            onUploadDone: function (result) {
                let self = this;
                if(result.type === 'info') {
                    let files = result.data.files;
                    self.enrollfile = [];
                    self.enrollfile.push(files[0]);

                } else {
                    this.$message.success(result.message);
                }
            },
            deleteFile: function (index) {
                this.enrollfile.removeAt(index.trackKey);
            },

            getCallBidDoc: function () {
                let self = this;
                let postData = {};
                postData.id = self.docId;
                let lastMsgBoxDlg = MsgBox.loading();
                callBidApi.getCallBidDocInfo(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == 'info') {
                        self.callBidDocInfo = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            getBizTplList: function () {
                let self = this;
                let lastMsgBoxDlg = MsgBox.loading();
                merchtComnApi.getBizTplList({}, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == "info") {
                        self.bizTplList = result.data;
                    } else {
                        MsgBox.warning(result.messgae);
                    }
                })
            },
            getBizNoticeContentModel: function () {
                let self = this;
                if(Utils.isNoB(self.bizTplId)) {
                    MsgBox.warning("请选择模板");
                    return false;
                }
                let postdata = {};
                postdata.bizTplId = self.bizTplId;
                postdata.callBidId = self.docId;
                let lastMsgBoxDlg = MsgBox.loading();
                callBidApi.getCallBidNoticePreviewText(postdata, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == "info") {
                        self.$set(self.callBidNotice, "content", result.data || '');
                    }
                })
            },
            getCallBidNotice: function () {
                let self = this;
                let params = {};
                params.id = self.id;
                let lastMsgBoxDlg = MsgBox.loading();
                callBidApi.getCallBidNotice(params, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == "info") {
                        let callBidNotice = result.data;

                        let file = {};
                        file.fileBrowseUrl = callBidNotice.fileBrowseUrl;
                        file.fileDownloadUrl = callBidNotice.fileDownloadUrl;
                        file.fileExtName = callBidNotice.fileExtName;
                        file.fileName = callBidNotice.fileName;
                        file.fileMd5 = callBidNotice.fileMd5;
                        file.fileUuid = callBidNotice.fileUuid;
                        self.enrollfile.push(file);
                        self.callBidNotice = callBidNotice;
                        self.$refs.theCkEditor.setContent(callBidNotice.content);
                    }
                })
            },
            insertImageUrlsHtml: function (ckEditor, imageUrl) {

                let imageHtmlTpl = '<span><img src="{0}" /></span><br />';
                //
                var imageHtml = imageHtmlTpl.format(imageUrl);
                ckEditor.insertHtml(imageHtml + '<br/>');

            },
            showDialogIntroImg: function (ckEditor) {
                let self = this;
                let dlg = Vue.$showDialog({
                    title: "介绍相册图片",
                    width: 400,
                    height: 300,
                    showCloseBtn: true,
                    template: '<div v-loading="loading" element-loading-text="保存中...">' +
                    '<swb-file-upload fileGroup="file-misc" :onBeforeUpload="onBeforeUpload" :onProgress="onProgress" :onDone="onUploadDone"></swb-file-upload>' +
                    '</div>',
                    data: {
                        loading: false,
                        files: [],
                    },
                    okVisible: false,
                    cancelVisible: false,
                    methods: {
                        //上传前（进行验证检查）处理，可以返回false取消上传
                        onBeforeUpload: function (fileItems, uploader) {
                            if(fileItems.length === 0) {
                                this.$alert("喂，你还没选择要上传的文件吧");
                                return false;
                            }
                        },
                        //上传进度处理
                        onProgress: function (progress) {
                            let selfDelf = this;
                            selfDelf.percentage = Math.floor((progress.loaded / progress.total) * 100);
                        },
                        //上传完毕处理（根据result.type判断是否有误）
                        onUploadDone: function (result) {
                            let selfDelf = this;
                            if(result.type === "info") {
                                let files = result.data.files;
                                // selfDelf.files =  files;
//                                console.log(files);
                                self.insertImageUrlsHtml(ckEditor, files[0].fileBrowseUrl);
                                dlg.close();
                                // return files;
                            } else {
                                selfDelf.$message.error(result.message);
                            }

                        },
                    },
                    lifecycle: {}
                });
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                //
                self.$refs['shNoticeFormInfo'].validate(function (valid) {
                    if(valid) {
                        let content = self.$refs.theCkEditor.getContent() || null;
                        let digest = self.$refs.theCkEditor.getText() || null;
                        let enrollfile = self.enrollfile;
                        if(content != null && enrollfile.length > 0) {
                            let callBidNotice = {};
                            callBidNotice.id = self.id;
                            callBidNotice.title = self.callBidNotice.title;
                            callBidNotice.docId = self.docId;
                            callBidNotice.content = content;
                            callBidNotice.digest = digest.substring(0, 250);
                            callBidNotice.fileUuid = enrollfile[0].fileUuid;
                            callBidNotice.fileExtName = enrollfile[0].fileExtName;
                            let callBidDoc = {};
                            callBidDoc.id = self.docId;
                            if(self.radio2) {

                                let callBidDocInfo = self.callBidDocInfo;
                                if(!Utils.isNoB(callBidDocInfo.enrollCloseTime)) {
                                    callBidDoc.enrollCloseTime = callBidDocInfo.enrollCloseTime.format("yyyy-MM-dd HH:mm");
                                }
                                if(!Utils.isNoB(callBidDocInfo.openTime)) {
                                    callBidDoc.openTime = callBidDocInfo.openTime.format("yyyy-MM-dd HH:mm");
                                }
                                if(!Utils.isNoB(callBidDocInfo.closeTime)) {
                                    callBidDoc.closeTime = callBidDocInfo.closeTime.format("yyyy-MM-dd HH:mm");
                                }
                                if(!Utils.isNoB(callBidDocInfo.resultPublishTime)) {
                                    callBidDoc.resultPublishTime = callBidDocInfo.resultPublishTime.format("yyyy-MM-dd HH:mm");
                                }
                                if(callBidDoc.enrollCloseTime >= callBidDoc.openTime) {
                                    result.type = "warn";
                                    result.message = "报名截至时间不能大于投标开始时间"
                                    return result;
                                }
                                if(callBidDoc.openTime >= callBidDoc.closeTime) {
                                    result.type = "warn";
                                    result.message = "投标开始时间不能大于投标结束时间"
                                    return result;
                                }
                                if(callBidDoc.closeTime >= callBidDoc.resultPublishTime) {
                                    result.type = "warn";
                                    result.message = "投标结束时间不能大于公布结果时间"
                                    return result;
                                }
                                callBidNotice.callBidDoc = callBidDoc;
                            }
                            result.type = "info";
                            result.data = callBidNotice;
                        } else {
                            result.type = "warn";
                            result.message = "请添加必须的信息";
                        }
                    } else {
                        result.type = "warn";
                        result.message = "请添加必须的信息";

                    }

                });
                return result;
            }
        }

    }
</script>



// WEBPACK FOOTER //
// src/compo/callbid/CallBidNoticeSave.vue